import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  type: ToastType
  title: string
  message?: string
  duration?: number
}

let toastIdCounter = 0

export const useNotificationStore = defineStore('notifications', () => {
  const toasts = ref<Toast[]>([])

  function addToast(toast: Omit<Toast, 'id'>): void {
    const id = `toast-${++toastIdCounter}`
    const duration = toast.duration ?? 5000

    toasts.value.push({ ...toast, id })

    if (duration > 0) {
      setTimeout(() => removeToast(id), duration)
    }
  }

  function removeToast(id: string): void {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  function success(title: string, message?: string): void {
    addToast({ type: 'success', title, message })
  }

  function error(title: string, message?: string): void {
    addToast({ type: 'error', title, message, duration: 8000 })
  }

  function warning(title: string, message?: string): void {
    addToast({ type: 'warning', title, message })
  }

  function info(title: string, message?: string): void {
    addToast({ type: 'info', title, message })
  }

  return {
    toasts,
    addToast,
    removeToast,
    success,
    error,
    warning,
    info,
  }
})
